const TABS = Object.freeze({
  In: 0,
  Out: 1
});
export default TABS;
